export interface Route {
  path: string;
  Component: React.LazyExoticComponent<React.ComponentType<any>>;
}

export enum STATIC_PAGES_PATHS {
  SUBSCRIPTION_TERMS = 'subscription-terms',
  SESSION_RULES = 'session-rules',
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  SUPPORT = 'support',
}
